<template>
    <div class="viewContainer" v-resize="onResize">
        <v-container class="pa-0">
            <v-img
                :src="topBgImg"
                :key="topBgImg"
                :min-height="topBgImgHeight"
                :aspect-ratio="topBgImgAspectRation"
                transition="fade-transition"
            >
                <v-container class="inner-container">

                    <v-card class="mt-md-12 mt-0 content-tabs-wrapper" tile elevation="0">
                        <v-tabs
                            :color="($store.state.app.dark) ? 'white' : 'black'"
                            class="px-5 content-tabs"
                            icons-and-text
                            height="100"
                            slider-size="4"
                            show-arrows
                            v-model="activeTab"
                        >
                            <v-tabs-slider></v-tabs-slider>

                            <v-tab class="no-caps" :ripple="false" key="0">
                                {{ $t('mtx_email_verification') }}
                                <v-icon size="24">mdi-email-variant</v-icon>
                            </v-tab>

                        </v-tabs>
                        <v-divider/>
                    </v-card>
                    <v-tabs-items v-model="tab" style="background-color: transparent;">
                        <v-tab-item value="tab-0">
                            <v-container class="pa-0">
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        sm="9"
                                        md="6"
                                    >


                                        <v-card flat tile class="content-tabs-card pa-5 mb-0 mb-md-12" elevation="0">
                                            <v-card-text>
                                                <div v-if="!loading">
                                                    <div v-if="validEmailVerificationCode">
                                                        {{ $t('mtx_email_verification_success') }}
                                                        {{ $t('mtx_You_must_click' ) }} <router-link :to="{name: 'login'}">{{ $t('mtx_Here') }}</router-link> {{ $t('to') }} {{ $t('login') }}.
                                                    </div>
                                                    <div v-else>
                                                        {{ $t('mtx_email_verification_fail') }}
                                                        {{ $t('mtx_Click' ) }} <router-link :to="{name: 'login'}">{{ $t('mtx_Here') }}</router-link> {{ $t('to') }} {{ $t('login') }}.
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    {{ $t('mtx_validating_email_addrress') }}
                                                </div>
                                            </v-card-text>
                                        </v-card>


                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </v-tabs-items>
                </v-container>
            </v-img>
        </v-container>
    </div>
</template>

<script>
    export default {
        data: () => ({
            tab: 'tab-0',
            topBgImg: 'about:blank',
            topBgImgHeight: null,
            topBgImgDefaultHeight: 780,
            topBgImgAspectRation: 1.7778,
            topBgImgs: [],
            validEmailVerificationCode: true,
            activeTab: 0,
            loading: true
        }),
        created() {
            // Tab images
            this.topBgImgs = [
                this.$init.config.schemeAndHost + '/img/reset-password-tab.jpg'
            ]

            // Set image depending on the size of the browser window
            if (window.innerWidth > 760) {
                this.topBgImg = this.topBgImgs[0]
                this.topBgImgHeight = this.topBgImgDefaultHeight
                this.topBgImgAspectRation = 1.7778
            } else {
                this.topBgImgHeight = null
                this.topBgImgAspectRation = 3
            }

            // Confirm email
            let code = this.$route.params.code
            this.axios
                .get('/auth/email-verification/' + code, { params: {locale: this.$i18n.locale} })
                .then(response => {
                    if (response.data.status === 'success') {
                        this.validEmailVerificationCode = true
                    } else {
                        this.validEmailVerificationCode = false
                    }
                    this.loading = false
                })
                .catch(() => {
                    this.validEmailVerificationCode = false
                })
        },
        methods: {
            onResize () {
                if (window.innerWidth <= 760) {
                    this.topBgImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                    this.topBgImgHeight = null
                    this.topBgImgAspectRation = 3
                } else if (this.topBgImg == 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=') {
                    this.topBgImg = this.topBgImgs[0]
                    this.topBgImgHeight = this.topBgImgDefaultHeight
                    this.topBgImgAspectRation = 1.7778
                }
            }
        },
        watch: {
            tab: function (val) {
                if (window.innerWidth > 960) {
                    this.topBgImg = this.topBgImgs[0]
                    this.topBgImgHeight = this.topBgImgDefaultHeight
                    this.topBgImgAspectRation = 1.7778
                }
            }
        }
    };
</script>
